interface PlatformCardProps {
  platform: {
    id: string;
    name: string;
    description: string;
    icon: string;
  };
  isSelected: boolean;
  onToggle: (platformId: string) => void;
}

export default function PlatformCard({
  platform,
  isSelected,
  onToggle,
}: PlatformCardProps) {
  return (
    <button
      type="button"
      onClick={() => onToggle(platform.id)}
      className={`card text-left transition-all duration-200 hover:scale-105 ${
        isSelected
          ? 'border-4 border-black dark:border-gray-300 shadow-brutal-lg'
          : 'border-2 border-gray-300 dark:border-gray-700'
      }`}
    >
      <div className="flex items-start gap-4">
        {/* Icon */}
        <div className="text-4xl">{platform.icon}</div>

        {/* Content */}
        <div className="flex-1">
          <h3 className="font-bold text-lg mb-1 dark:text-gray-100">
            {platform.name}
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            {platform.description}
          </p>
        </div>

        {/* Checkbox */}
        <div className="flex-shrink-0">
          <div
            className={`w-6 h-6 rounded border-2 flex items-center justify-center ${
              isSelected
                ? 'bg-black dark:bg-gray-100 border-black dark:border-gray-300'
                : 'border-gray-300 dark:border-gray-700'
            }`}
          >
            {isSelected && (
              <svg
                className="w-4 h-4 text-white dark:text-black"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </div>
        </div>
      </div>
    </button>
  );
}
